import React from "react";
import FAQ from "../Utils/FAQ";

const LANDING_FAQS = [
  {
    question: "What services does Jeremy Solutions offer?",
    answer:
      "We offer a comprehensive range of digital services including Web Design, GIS Solutions, Digital Marketing, and Art Sales. Each service is tailored to meet your specific business needs and objectives.",
  },
  {
    question: "How long does it take to complete a project?",
    answer:
      "Project timelines vary based on complexity and scope. Web design projects typically take 2 weeks, GIS solutions 2-3 months, and marketing campaigns are ongoing. We provide detailed timelines during initial consultations.",
  },
  {
    question: "Do you provide ongoing support?",
    answer:
      "Yes, we offer 6 months of complimentary technical support with all our solutions. After this period, we provide continued support through customized Service Level Agreements (SLAs) based on your needs.",
  },
  {
    question: "What is your pricing structure?",
    answer:
      "Our pricing is transparent and project-based. We offer different packages for each service, starting from Ksh. 15,000 for basic web design to custom enterprise solutions. Contact us for a detailed quote based on your requirements.",
  },
  {
    question: "Can you handle multiple services for one client?",
    answer:
      "Absolutely! We often provide integrated solutions combining multiple services. For example, we can design your website, implement GIS features, and manage your digital marketing campaigns - all under one roof.",
  },
  {
    question: "How do I get started?",
    answer:
      "Getting started is easy! Simply contact us through our website, email, or phone. We'll schedule a free consultation to discuss your needs, provide recommendations, and develop a tailored solution for your business.",
  },
];

export default function LandingFAQ() {
  return (
    <FAQ
      title="Frequently Asked Questions"
      subtitle="Find answers to common questions about our services and solutions"
      faqs={LANDING_FAQS}
    />
  );
}
